module.exports = __webpack_public_path__ + "84214187dc64ec965d7ef72734622f81.svg";